/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xIDQuNjFINC42MVYxSDUuNjFWNS42MUgxVjQuNjFaTTQuNjEgMTEuMzlIMVYxMC4zOUg1LjYxVjE1SDQuNjFWMTEuMzlaTTExLjM5IDQuNjFWMUgxMC4zOVY1LjYxSDE1VjQuNjFIMTEuMzlaTTExLjM5IDE1SDEwLjM5VjEwLjM5SDE1VjExLjM5SDExLjM5VjE1WiIgZmlsbD0iaW5oZXJpdCIvPg==";